
(function () {
    'use strict';
    app.controller('inviteController', ['$scope', 'LoginService', '$location', '$cookies', 'AuthenticationService', 'progressBarService', '$rootScope', '$timeout', function ($scope, loginService, $location, $cookies, AuthenticationService, progressBarService, $rootScope, $timeout) {
        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
            $location.path('/login');
            return
        }

        $scope.isError = false;
        $scope.isSuccess = false;
        $scope.inviteData = [{ emailID: "" }, { emailID: "" }, { emailID: "" }, { emailID: "" }, { emailID: "" }];
        $scope.user = getLocalValue("emailId");
        $scope.isValidUsers = false;
        var name = getLocalValue("fullName").split(' ');
        $scope.firstName = name[0];
        $scope.lastName = name[1];
        $scope.isDisabled = true;

        $scope.add = function () {
            //$scope.isDisabled = true;
            if ($scope.inviteData.length < 10) {
                $scope.inviteData.push({ emailID: "" });
                //$scope.isDisabled = true;
            }
            //var i, count = 0;
            //var emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            //for (i = 0; i < $scope.inviteData.length; i++) {
            //    if ($scope.inviteData[i].emailID != "" && $scope.inviteData[i].emailID != undefined) {
            //        if (emailregx.test($scope.inviteData[i].emailID)) {
            //            count = count + 1;
            //        } else {
            //            count = 0;
            //        }
            //    }
            //}
            //if (count > 0) {
            //    $scope.isDisabled = false;
            //}
        }
        $scope.remove = function (index) {
            $scope.isDisabled = true;
            if ($scope.inviteData.length > 1) {
                $scope.inviteData.splice(index, 1);
            }
            var i, count = 0;
            var emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            for (i = 0; i < $scope.inviteData.length; i++) {
                if ($scope.inviteData[i].emailID != "" && $scope.inviteData[i].emailID != undefined) {
                    if (emailregx.test($scope.inviteData[i].emailID)) {
                        count = count + 1;
                        $('#inviteUserId' + i).removeClass('border-red');
                    } else {
                        count = 0;
                        $('#inviteUserId' + i).addClass('border-red');
                    }
                }

                if ($scope.inviteData[i].emailID == undefined) {
                    $('#inviteUserId' + i).addClass('border-red');
                }
                else {
                    $('#inviteUserId' + i).removeClass('border-red');
                }
            }
            if (count > 0) {
                $scope.isDisabled = false;

            } else {
                if ($scope.inviteData.length >= 1) {
                    $scope.isDisabled = true;
                }
            }
            //$scope.checkInviteEmailID();
        }

        var hideMessage = function () {

            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.isModalError = false;
            $scope.isModalSuccess = false;
        }

        $scope.checkValidEmail = function (e) {
            var count = 0, i, emailregx;
            emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if ($(e.currentTarget).val() == $scope.user) {
                $scope.isDisabled = true;
            } else {
                $scope.isDisabled = false;
            }

            for (i = 0; i < $scope.inviteData.length; i++) {
                if ($scope.inviteData[i].emailID == $scope.user) {
                    $scope.isDisabled = true;
                    return false;
                }

                else if ($scope.inviteData[i].emailID != "" && $scope.inviteData[i].emailID != undefined) {
                    if (emailregx.test($scope.inviteData[i].emailID)) {

                        $('#inviteUserId' + i).removeClass('border-red');
                        count = count + 1;
                    }
                    else {
                        count = 0;
                        $('#inviteUserId' + i).addClass('border-red');
                    }
                }

                else if ($scope.inviteData[i].emailID == undefined) {
                    $('#inviteUserId' + i).addClass('border-red');
                }
                else {
                    $('#inviteUserId' + i).removeClass('border-red');
                }
            }
            if (count > 0) {
                $scope.isDisabled = false;

            } else {
                if ($scope.inviteData.length >= 1) {

                    $scope.isDisabled = true;

                }
            }
            //$scope.checkInviteEmailID();

        }



        $scope.inviteMember = function () {
            //$scope.validateInviteMemmber()
            //{

            progressBarService.showProgressBar();

            $rootScope.$broadcast('reloadCaptcha', {});

            //var userId = $cookies.get("UserId");
            var affiliationName = getLocalValue("affiliationName");



            var i, memberList = [];

            for (i = 0; i < $scope.inviteData.length; ++i) {
                if ($scope.inviteData[i].emailID.length > 0) {
                    memberList.push($scope.inviteData[i].emailID);
                }
            }

            angular.forEach(memberList, function (value, key) {
                angular.forEach(memberList, function (value1, key1) {
                    if (key != key1) {
                        if (value.toLowerCase() == value1.toLowerCase()) {
                            memberList.splice(key, 1);
                        }
                    }
                });
            });


            var firstName = "";
            loginService.Invite(memberList, firstName, $scope.firstName, $scope.lastName).then(function (response) {

                if (response != null && response.data != undefined) {
                    if (response.data.count == 0 && response.data.errorMessage.length == 0) {
                        $scope.message = "You can send only 10 invites at a time."
                        $scope.isError = true;
                        $scope.isSuccess = false;
                    } else if (response.data.errorMessage.length > 0) {
                        if (response.data.status == 3) {
                            $scope.message = response.data.errorMessage;
                        } else {
                            $scope.message = "Invitation is already sent to " + response.data.errorMessage;
                        }
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        $scope.inviteData = [{ emailID: "" }, { emailID: "" }, { emailID: "" }, { emailID: "" }, { emailID: "" }];
                        // $('form[name="inviteForm"]').trigger('reset');
                        $scope.isDisabled = true;
                    }
                    else {
                        if (response.data.count != 1) {
                            $scope.message = "Email has been sent to " + response.data.count + " member(s)!";
                        } else {
                            $scope.message = "Email has been sent to " + response.data.count + " member!";
                        }

                        $scope.isError = false;
                        $scope.isSuccess = true;
                        $scope.inviteData = [{ emailID: "" }, { emailID: "" }, { emailID: "" }, { emailID: "" }, { emailID: "" }];
                        // $('form[name="inviteForm"]').trigger('reset');
                        $scope.isDisabled = true;
                        //$timeout(hideMessage, 10000);
                        //to clear captcha value
                        //$('.numbersOnly').val('');
                    }
                }
                else {
                    $scope.message = GetMessage.ApiError;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                progressBarService.hideProgressBar();
            });

            // }

        };

        //$scope.checkInviteEmailID = function () {
        //    $scope.isValidEmailID = true;
        //    angular.forEach($scope.inviteData, function (value, key) {
        //        angular.forEach($scope.inviteData, function (value1, key1) {
        //            if (key != key1) {
        //                if (value.emailID == "" || value1.emailID == "" || value.emailID.toLowerCase() == value1.emailID.toLowerCase()) {
        //                    $scope.isValidEmailID = false;
        //                }
        //            } else if ($scope.inviteData.length == 1 && value.emailID != "") {
        //                $scope.isValidEmailID = true;
        //            }
        //        });
        //    });
        //}


        //$scope.validateInviteMemmber = function () {

        //    var returnVal = true;
        //    var isEmailEnter = false;

        //    angular.forEach($("#CountInput input[type='text']"), function (value, index) {
        //        if (angular.element(value).val() != '') {
        //            var emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        //            if (emailregx.test(angular.element(value).val())&&!user) {

        //                $(value).siblings("label").find("span").fadeOut();
        //                isEmailEnter = true;
        //            }
        //            else {

        //                if (returnVal) {
        //                    $(value).focus();
        //                }
        //                $(value).siblings("label").find("span").fadeIn();
        //                returnVal = false;
        //            }

        //        }
        //        else {

        //            if (returnVal && !isEmailEnter) {
        //                $(value).focus();
        //            }
        //            $(value).siblings("label").find("span").fadeIn();
        //            returnVal = isEmailEnter;
        //        }
        //    })
        //    if (!$scope.captchaValid) {
        //        return false;
        //    }
        //    if (!returnVal) {

        //        this.inviteForm.$dirty = true;
        //        var FieldShellelements, i;
        //        FieldShellelements = $("#CountInput div input");
        //        for (i = 0; i < FieldShellelements.length; i++) {
        //            var inviteUserName = FieldShellelements[0].name;
        //            this.inviteForm['inviteUserName' + i].$dirty = true;
        //        };
        //    }
        //    return returnVal;
        //}

        $scope.getPastedText = function (event, index) {
            setTimeout(function () {
                $scope.inviteData[index].emailID = $(event.currentTarget).val();
                $scope.checkValidEmail(event);
                $scope.$apply();
            }, 1);
        }

    }]);

})();



